<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex pa-0 ma-0">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ma-0 pa-0 mt-4">
            fa-caret-down</v-icon
          >
        </div>
      </template>

      <v-list color="white">
        <v-list-item-group color="white">
          <v-list-item color="header" @click="about">
            <v-icon color="header">fa-info-circle</v-icon>
            <v-list-item-title
              class="ml-3 font-weight-medium"
              style="cursor: pointer"
              color="header"
            >
              {{ $tc("nav.about") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            color="header"
            :href="'https://ds9-doc.herokuapp.com/'"
            target="_blank"
          >
            <v-icon color="header">fa-book-open</v-icon>
            <v-list-item-title
              class="ml-2 font-weight-medium"
              style="cursor: pointer"
              color="header"
            >
              {{ $tc("nav.docu") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item color="header" @click="openSafesty()">
            <v-icon color="header">fas fa-user-shield</v-icon>
            <v-list-item-title
              class="ml-2 font-weight-medium"
              style="cursor: pointer"
              color="header"
            >
              {{ $tc("nav.safety") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item color="header" @click="logout()">
            <v-icon color="header">fa-sign-out-alt</v-icon>
            <v-list-item-title
              class="ml-2 font-weight-medium"
              style="cursor: pointer"
              color="header"
            >
              {{ $tc("nav.logout") }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <about :about="showAbout" @change="aboutChange" />
    <FormSafety
      :show="openDialogPass"
      :key="openDialogPass"
      @close="closeSafety"
    />
  </div>
</template>

<script>
import About from "./About.vue";
import FormSafety from "./FormSafety.vue";

export default {
  components: { About, FormSafety },

  data() {
    return {
      openDialogPass: false,
      showAbout: false,
    };
  },
  methods: {
    openSafesty() {
      this.openDialogPass = true;
    },
    closeSafety() {
      this.openDialogPass = false;
    },
    logout() {
      localStorage.removeItem("empId");
      localStorage.removeItem("auditRegis");
      localStorage.removeItem("token");
      localStorage.removeItem("operId");
      localStorage.removeItem("rolId");
      localStorage.removeItem("name");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("asegurables");
      localStorage.removeItem("init");
      localStorage.removeItem("fechaFiltroDesde");
      localStorage.removeItem("fechaFiltroHasta");

      this.$router.push({ path: "/signin" });
    },
    about() {
      this.showAbout = true;
    },
    aboutChange(value) {
      this.showAbout = value;
    },
  },
};
</script>

<style></style>
